import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b4d402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "top-tabs tabs-buttons" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = ["disabled", "title"]
const _hoisted_7 = { class: "content-container" }
const _hoisted_8 = { class: "top-content" }
const _hoisted_9 = { class: "flex-row-centered" }
const _hoisted_10 = { class: "center-buttons" }
const _hoisted_11 = { class: "table-container" }
const _hoisted_12 = {
  key: 0,
  style: {"padding-top":"1rem"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Loan Re-Payments:")
], -1))

import MarketSelector from "@/components/MarketSelector.vue";
import { ITableExpose } from "@/components/TablePersistentChecking.vue";
import { DrawdownHelper } from "@/services/helpers/DrawdownHelper";
import { marketSelection } from "@/services/helpers/Helper";
import { computed, onMounted, ref } from "vue";
import TablePersistentChecking from "@/components/TablePersistentChecking.vue";
import { VatLoan } from "@/models/VatLoan";
import DatePeriod from "@/types/DatePeriod";
import { GetAuthLevel } from "@/config/AuthConfig";
import { authService } from "@/auth/authSingleton";
import LoanPaymentPopUp from "@/components/VATLoan/LoanPaymentPopUp.vue";
import { VatLoanRepayment } from "@/models/Ledgering/VatLoanRepayment";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'VatLoans',
  setup(__props) {

const showOutstanding = ref(true);
const urlParams = process.env.VUE_APP_GET_VAT_LOAN_REPAYMENT_URL_PARAMS;

//Services
const DrawdownServices: DrawdownHelper = new DrawdownHelper();
const userRoleLevel = GetAuthLevel(authService.getUsersRole());
const confirmVisible = computed(() => userRoleLevel > 4 && showOutstanding.value);

// ERRORS
const infoError = ref(false);

// TABLE
const isLoading = ref(false);
const table = ref<ITableExpose<VatLoan>>();
const checkedRow = ref<VatLoan>();
const selectedRow = ref<VatLoan | undefined>();
const allLoans = ref<VatLoan[]>([]);
const rowCount = computed(() => {return (showOutstanding ? 40 : 10)})

const outstandingRows = ref<VatLoan[]>([]);
const repaidRows = ref<VatLoan[]>([]);
const colsLoans: Array<keyof VatLoan> = [
    "Market",
    "DrawdownDate",
    "VatLoanAmount",
    "VatLoanPeriod",
    "RemainingBalance",
    "UserEmail"
];
const colsRepaidLoans: Array<keyof VatLoan> = [
    "Market",
    "DrawdownDate",
    "VatLoanAmount",
    "VatLoanPeriod",
    "UserEmail"
];
const repaymentCols: Array<keyof VatLoanRepayment> = [
    "RepaymentDate",
    "RepaymentAmount",
    "RepaymentPeriod",
    "UserEmail"
];
const repayments = computed(() => {
    if (!checkedRow.value || checkedRow.value.Repayments?.length == 0) {
        return undefined;
    }

    return checkedRow.value.Repayments
        ? checkedRow.value.Repayments.map((item) => ({
              RepaymentAmount: item.RepaymentAmount,
              RepaymentDate: item.RepaymentDate,
              RepaymentPeriod: new DatePeriod(item.RepaymentPeriod),
              UserEmail: item.UserEmail,
          }))
        : undefined;
});

onMounted(async () => {
    getVatLoans();
});

async function getVatLoans() {
    try {
        infoError.value = false;
        const data = await DrawdownServices.getVatLoans(
            urlParams!,
            marketSelection.value
        );
        allLoans.value = data.map((x) => new VatLoan(x));

        repaidRows.value = allLoans.value.filter((x) => x.RemainingBalance === 0);
        outstandingRows.value = allLoans.value.filter((x) => x.RemainingBalance! > 0);
    } catch (error) {
        useNotifierWithErrFormatter().error({error, errorType: "Getting Vat Loans"});
        infoError.value = true;
    } finally {
        isLoading.value = false;
    }
}

function updateCheckedRows() {
    checkedRow.value = table.value?.GetChecked()[0];
}

function updateSelection() {
    getVatLoans();
}

function proceedToPayment() {
    if (!checkedRow.value) {
        window.alert("Warning: no payment has been selected to confirm yet.");
    }
    selectedRow.value = checkedRow.value;
}

const tabsKey = ref(0);
function ToggleTabs() {
    tabsKey.value += 1;
    ResetTabs();
}

function ResetTabs() {
    showOutstanding.value = !showOutstanding.value;
    setTimeout(() => {
        table.value?.ResetSort();
    }, 0);
}
function refreshAfterConfirm() {
    checkedRow.value = undefined;
    selectedRow.value = undefined;
    getVatLoans();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-left ${showOutstanding.value ? 'selected' : 'unselected'}`),
            disabled: showOutstanding.value,
            title: 
                        showOutstanding.value
                            ? 'Currently viewing outstanding VAT Loans'
                            : 'Click to view Repaid VAT Loans'
                    ,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (ToggleTabs()))
          }, " Outstanding ", 10, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-right ${showOutstanding.value ? 'unselected' : 'selected'}`),
            disabled: !showOutstanding.value,
            title: 
                        !showOutstanding.value
                            ? 'Currently viewing Repaid VAT Loans'
                            : 'Click to view Outstanding VAT Loans'
                    ,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (ToggleTabs()))
          }, " Repaid ", 10, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(MarketSelector, {
            onChange: updateSelection,
            enableSE: ""
          }),
          _withDirectives(_createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: proceedToPayment,
              class: "incident-nav-button"
            }, " Confirm Payment ")
          ], 512), [
            [_vShow, confirmVisible.value]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(TablePersistentChecking, {
          ref_key: "table",
          ref: table,
          Rows: showOutstanding.value ? outstandingRows.value : repaidRows.value,
          Cols: showOutstanding.value ? colsLoans : colsRepaidLoans,
          HasCheckBox: true,
          HasError: infoError.value,
          SingleSelection: true,
          CheckCallBack: updateCheckedRows,
          SplitColKeys: "",
          RowsPerPage: rowCount.value,
          "onUpdate:RowsPerPage": _cache[2] || (_cache[2] = ($event: any) => ((rowCount).value = $event))
        }, {
          DrawdownDate: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.value.DrawdownDate!.toLocaleString("sv-SE").split(" ")[0]), 1)
          ]),
          _: 1
        }, 8, ["Rows", "Cols", "HasError", "RowsPerPage"]),
        (repayments.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode(TablePersistentChecking, {
                ref: "secondTable",
                Rows: repayments.value,
                Cols: repaymentCols,
                SplitColKeys: ""
              }, null, 8, ["Rows"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(LoanPaymentPopUp, {
          modelValue: selectedRow.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedRow).value = $event)),
          onConfirm: refreshAfterConfirm
        }, null, 8, ["modelValue"])
      ])
    ])
  ], 64))
}
}

})